var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/cell_phone/index.js
 ** module id = 542
 ** module chunks = 0
 **/